/**
 * useTutorTrainingData — la lecture de « Ta formation » : à l'ouverture, au « Réessayer » d'une
 * erreur, et avant de repasser le quiz (le serveur remélange les choix à chaque lecture), comme
 * `TutorTrainingScreen.js`. La réponse arrive dans le réducteur `tutorTraining` (patron A) : rien ne se
 * consomme ici.
 */
import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { tutorTrainingService } from "../../../../../../data/services/tutorTrainingService"

export function useTutorTrainingData() {
    const dispatch = useDispatch()

    const fetch = useCallback(() => {
        dispatch(apiRequest(tutorTrainingService.getTutorTraining) as never)
    }, [dispatch])

    useEffect(fetch, [fetch])

    return { fetch }
}
